<h4 class="expandable-section-title" [class.is-modern]="design == 'modern'" [class.hidden]="isEditing" [class.help-title]="titleType === 1" [class.is-expanded]="isExpanded">
  <span class="edit-title__text" [innerHTML]="title"></span>
  @if (allowEdit) {
    <button class="my-button my-button--small my-button--icon-only" type="button" (click)="startEditName($event)">
      <span translate="no" class="material-icon">edit</span>
    </button>
  }
</h4>
@if (allowEdit) {
  <form class="name-form" [formGroup]="nameForm" [ngClass]="{'is-editing': isEditing}" >
    <input class="name-input" autocomplete="off" formControlName="name"
      (keydown)="nameElementKeyDown($event)"
      (blur)="nameElementBlur()"
      (click)="clickedRenameInput($event)"
      maxlength="50"
      #cartNameElement  [class.hidden]="!isEditing" type="text">
    </form>
  }
